var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_catalog",
          attrs: {
            id: "modal-catalog",
            title: _vm.title,
            size: "lg",
            "modal-class": "custom-modal",
            centered: "",
            lazy: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.handleCancel }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.isViewMode ? "Закрыть" : "Отменить") +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isViewMode
                        ? _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              attrs: { disabled: _vm.loading },
                              on: { click: _vm.handleOk }
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v("\n          Сохранить\n        ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u(
              [
                {
                  key: "loading",
                  fn: function() {
                    return [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-row",
                            { staticClass: "mt-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-skeleton", {
                                    staticClass: "mb-2",
                                    attrs: { width: "40%", height: "16%" }
                                  }),
                                  _vm._v(" "),
                                  _c("b-skeleton", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      type: "input",
                                      width: "100%",
                                      height: "30%"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-skeleton", {
                                    staticClass: "mb-0",
                                    attrs: { width: "85%", height: "15%" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._t("optional-skeleton"),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-skeleton", {
                                    attrs: {
                                      type: "input",
                                      width: "30%",
                                      height: "45%"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.handleOk.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "group-name",
                                label: _vm.nameLabel,
                                "invalid-feedback": _vm.nameInvalidFeedback,
                                state: _vm.nameState,
                                description: _vm.descriptionLabel
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  size: "sm",
                                  state: _vm.nameState,
                                  disabled: _vm.isViewMode,
                                  trim: ""
                                },
                                model: {
                                  value: _vm.newItem.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newItem, "name", $$v)
                                  },
                                  expression: "newItem.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._t("optional-fields", null, {
                            model: _vm.newItem,
                            disabled: _vm.isViewMode
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                size: "md",
                                disabled: _vm.isViewMode || _vm.isCreateMode
                              },
                              model: {
                                value: _vm.newItem.active,
                                callback: function($$v) {
                                  _vm.$set(_vm.newItem, "active", $$v)
                                },
                                expression: "newItem.active"
                              }
                            },
                            [_vm._v("Активен / не активен")]
                          )
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87d616d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87d616d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Catalog.vue
// module id = null
// module chunks = 